module.exports = __webpack_public_path__ + "img/arrow-up-1-9.e80076b4.svg";